'use client';
import { MagneticButton } from './MagneticDiv';
import { MagneticText } from './MagneticText';

interface InputDesignProps {
  bgColor?: string;
  hoverBgColor?: string;
  textColor?: string;
  textHoverColor?: string;
  label: string;
  onClick?: () => void;
  className?: string;
}

function MagneticBtn({ onClick, label, bgColor, hoverBgColor, textColor, textHoverColor, className }: InputDesignProps) {
  return (
    <div onClick={onClick}>
      <MagneticButton className={`flex items-center justify-center font-fractul ${bgColor} ${hoverBgColor} ${textColor} ${textHoverColor} ${className} px-5 h-[40px] md:h-[48px] rounded-full transition-colors duration-300 ease-in-out`}>
        <div className='magnetic-button'>
          <MagneticText>{label}</MagneticText>
        </div>
      </MagneticButton>
    </div>
  );
}
export default MagneticBtn;
